module.exports = __webpack_public_path__ + "07ab1b876429df06d9b1c8cd79ae0496.MP3";